export default __webpack_public_path__ + "/dist/images/8654361.92448f8119ab053f00b8611706a43934.jpg";